<!--普通卷-->
<template>
  <div class="doExam" v-loading.fullscreen="commitStatus">
    <common-header :title="examName" />
    <div id="my-calculator"
         style="display: none;"></div>
    <div class="exam-wrapper">
      <div class="title clearfix">
        <!--答题区大题题型描述-->
        <exam-theme-title v-if="isStart"
                          :is-show-desc="false" />
        <!--答题区倒计时-->
        <timer v-if="endTimes>0" :end-times.sync="endTimes" />
      </div>
      <entry-page v-if="!isStart"
                  @ordinaryToNext="examStart" />
      <div class="examinationArea"
           v-if="isStart && isVisibleQueDetail">
        <div class="exam-con">
          <!-- 单选题、判断题 -->
          <template v-if="currentQuestion.quesTypeID === 1 || currentQuestion.quesTypeID === 3">
            <exam-single-choice @runCalc="runCalc"
                                @markToggleFn="markToggleFn"
                                :isShowProposal="isShowProposal"
                                :isShowAnswerQuestion="isShowAnswerQuestion"
                                :isShowAnswer.sync="isShowAnswer"
                                :isAnswerShow.sync="isAnswerShow"
                                :isShowQzSeat="isShowQzSeat"
                                :isShowCollect="isShowCollect"
                                :isShowPointAssessment="isShowPointAssessment"
                                :isShowVideoExplain="isShowVideoExplain"
                                :faqlUrl="faqlUrl" />
          </template>
          <!-- 多选题 -->
          <template v-if="currentQuestion.quesTypeID === 2">
            <exam-multiple-choice @runCalc="runCalc"
                                  @markToggleFn="markToggleFn"
                                  :isShowProposal="isShowProposal"
                                  :isShowAnswerQuestion="isShowAnswerQuestion"
                                  :isShowAnswer.sync="isShowAnswer"
                                  :isAnswerShow.sync="isAnswerShow"
                                  :isShowQzSeat="isShowQzSeat"
                                  :isShowCollect="isShowCollect"
                                  :isShowPointAssessment="isShowPointAssessment"
                                  :isShowVideoExplain="isShowVideoExplain"
                                  :faqlUrl="faqlUrl" />
          </template>
        </div>
        <!--底部公共按钮-->
        <div class="footer clearfix">
          <div class="right clearfix">
            <!-- <label><input type="checkbox"
                     :checked="currentQuestion.isMark"
                     :value="1"
                     @click="markToggleFn" />
              标记本题</label> -->
            <div class="opt clearfix">
              <prev-or-next @buttonFn="buttonChange">
                <button slot="list"
                        class="quesList"
                        @click="toggleQuesList(true,'1')">试题列表</button>
              </prev-or-next>
            </div>
            <a href="javascript:void(0)"
               @click="endToShowAlert"
               class="saveBtn" />
          </div>
        </div>
      </div>
      <exam-ques-list v-if="isVisibleQueList"
                      @quesFn="changeByQueList"
                      @backToPaper="toggleQuesList"
                      @savePaper="endToShowAlert" />
    </div>
    <exam-end :visible.sync="endExamFlag"
              :isHaveSubjective="isHaveSubjective"
              @viewResults="viewResults"
              @subjectiveQuestionsStore="subjectiveQuestionsStore" />
    <exam-end-alert :visible.sync="endExamAlertFlag"
                    :unAnswerLen="unAnswerLen"
                    @submit="endToSave" />
    <!-- <common-footer /> -->
    <iframe
      src="//www.chinaacc.com/include/vueFooter.shtml"
      width="100%"
      height="198px"
      scrolling="no"
      allowtransparency="true"
      frameborder="0"
      marginheight="0"
      marginwidth="0"
    ></iframe>
  </div>
</template>
<script>
import { getCookie, parseNumber } from '@/utils'
import mixin from './mixin'
import { CommonFooter, CommonHeader } from '@components/common'
import {
  examEnd,
  examEndAlert,
  ExamMultipleChoice,
  ExamQuesList,
  ExamSingleChoice,
  ExamThemeTitle,
  prevOrNext,
  Timer
} from '@components/exam'
import entryPage from './entry'

window._calc_element = 'my-calculator'

export default {
  name: 'OrdinaryExam',
  mixins: [mixin],
  components: {
    CommonHeader,
    CommonFooter,
    ExamThemeTitle,
    Timer,
    entryPage,
    ExamSingleChoice,
    ExamMultipleChoice,
    prevOrNext,
    ExamQuesList,
    examEnd,
    examEndAlert
  },
  data() {
    return {
      //常规参数
      flag: '',
      siteCourseID: '',
      temp: 1,
      bizID: '',
      spendTime: 0,
      courseID: '',
      source: 'centerPaper',
      saveBizID: '',
      centerID: '', // 收费普通卷有
      classID: '', // 收费普通卷有
      uid: '',
      //基础参数
      examName: '',
      isStart: false,
      endTimes: 0,
      timer: null, //计时器
      isVisibleQueDetail: true, //题目
      isVisibleQueList: false, //试题列表
      endExamFlag: false, //结束考试弹框
      endExamAlertFlag: false, //结束考试检查弹框
      unAnswerLen: 0, //未答题个数
      tenMinutesFlag: false, //十分钟倒计时弹框
      isHaveSubjective: false, //是否含有主观题
      alertWindow: {
        // 交卷弹窗
        show: false,
        courseName: '',
        unAnswerCount: 0,
        allQuestions: 0,
        isMultipleSelection: false, //是否多选题只选了一个答案
      },
      questionsMap: [],
      isShowProposal: false, //是否显示建议
      isShowAnswerQuestion: false, //是否显示答疑
      isShowAnswer: false, //是否显示答案项
      isAnswerShow: false, //是否显示答案
      isShowQzSeat: false, //是否显示题目位置
      isShowCollect: false, //是否显示收藏
      isShowPointAssessment: false, //是否显示知识点考核
      isShowVideoExplain: false, //是否显示视频讲解
      faqlUrl: '', //答疑跳转地址
      isTemp: false,
      commitStatus: false // 提交接口 执行状态
    }
  },
  watch: {
    endTimes(newVal) {
      document.title = this.timeFilter(newVal)
      if (newVal === 600) {
        this.tenMinutesFlag = true
      }
      if(newVal === 15){
        clearInterval(this.timer)
      }
      if (!this.endExamFlag && newVal === 0) {
        this.endToSubmit()
      }
    },
  },
  async mounted() {
    if(!this.checkLogin()){
      return
    }
    const {
      flag,
      siteCourseID,
      temp = 1,
      bizID = '',
      spendTime = 0,
      courseID,
      source = 'centerPaper',
      saveBizID = '',
      centerID,
      classID
    } = this.$route.query
    this.flag = flag
    this.siteCourseID = parseNumber(siteCourseID)
    this.temp = parseNumber(temp)
    this.bizID = parseNumber(bizID)
    this.spendTime = spendTime
    this.courseID = parseNumber(courseID)

    this.source = source
    this.saveBizID = parseNumber(saveBizID)
    this.uid = parseNumber(getCookie('cdeluid') || '')
    // 初级+中级+注会+税务师对应收费题库普通卷进入传递centerID然后组卷传递回来
    this.centerID = centerID ? parseNumber(centerID) : ''
    this.classID = classID ? parseNumber(classID) : ''
    await this.initExam()
    //计算器实例化
    this.$nextTick(() => {
      window.SetCalcType()
    })
  },
}
</script>
